export enum SectionRule {
    Default = 'default', // Don't track Progress
    TrackProgress = 'default_track_progress',
    Sequential = 'sequential',
}
